"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const js_base64_1 = require("js-base64");
class LoginUser {
    constructor(token, isTempToken = false) {
        this._isTempToken = false;
        this._token = '';
        this._data = {};
        this._id = '';
        this._token = token;
        if (!isTempToken) {
            this._data = JSON.parse(js_base64_1.Base64.decode(this._token.split('.')[1]));
            this._id = this._data.id;
        }
    }
    get id() {
        return this._id;
    }
    get isTempToken() {
        return this._isTempToken;
    }
    get data() {
        return this._data;
    }
    get token() {
        return this._token;
    }
}
exports.default = LoginUser;
//# sourceMappingURL=LoginUser.js.map